export default "__VITE_ASSET__BRVhLL3a__"